module.exports = __webpack_public_path__ + "img/Weapon_268.a30c9f65.png";